import { Typography } from '@mui/material'

import { HelperWrapper, ModalWrapper } from 'src/components'
import { DisconnectConfirmForm } from './form'

import { useStyles } from './styles'

interface IDeleteConfirmModalProps {
  open: boolean
  handleClose: () => void
  handleDelete: () => void | Promise<void>
}

export const DisconnectAccountModal = ({
  open,
  handleClose,
  handleDelete,
}: IDeleteConfirmModalProps) => {
  const classes = useStyles()

  const handleSubmit = async () => {
    await handleDelete()
  }

  return (
    <ModalWrapper className={classes.formWrapper} onClose={handleClose} open={open}>
      <div className={classes.sectionWrapper}>
        <Typography className={classes.title}>
          <HelperWrapper t="account-disconnect-form-title" />
        </Typography>
        <Typography align="center" className={classes.text}>
          <HelperWrapper t="account-disconnect-form-approve" />
        </Typography>
      </div>
      <DisconnectConfirmForm handleSubmit={handleSubmit} />
    </ModalWrapper>
  )
}
